<template>
  <div class="ProjectEdit__part">
    <violet-bar>Localité</violet-bar>
    <help-message>
      <h3 slot="title">Localité</h3>
      <p>
        La graphie de l'adresse est simple :
        <strong>XX rue/avenue/[...] Nom de la Rue</strong><br />Les coordonnées
        GPS se trouvent en allant sur Google Maps, et en repérant dans l'adresse
        de la page la latitude et longitude.<br />
        Par exemple, l'adresse :
        https://www.google.com/maps/place/Großdeuben/@<strong>51.2769867</strong>,<strong>12.3931037</strong>,11310m
        <br />
        montre que cet endroit est à 51.2769867 de latitude et 12.3931037 de
        longitude.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-third">
          <vertical-field>
            <label class="label" slot="label">Ville</label>
            <input type="text" class="input" v-model="project.city" />
          </vertical-field>
          <vertical-field>
            <label class="label" slot="label">Code Postal</label>
            <input type="text" class="input" v-model="project.zipcode" />
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label class="label" slot="label">Pays</label>
            <input type="text" class="input" v-model="project.country" />
          </vertical-field>
        </div>
        <div class="column is-one-third">
          <vertical-field>
            <label class="label" slot="label">Adresse</label>
            <input type="text" class="input" v-model="project.address" />
          </vertical-field>
          <vertical-field>
            <label for="" class="label" slot="label">Latitude</label>
            <input type="text" class="input" v-model="project.lat" />
          </vertical-field>
          <vertical-field>
            <label for="" class="label" slot="label">Longitude</label>
            <input type="text" class="input" v-model="project.lng" />
          </vertical-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit-Locality",
  components: { HelpMessage, VerticalField, VioletBar },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  }
};
</script>
